import React from 'react';

import { Avatar, AvatarFallback, AvatarImage } from '@repo/ui/avatar';

import { handleGenerateInitialsFromName } from 'helpers/format';

import { ReviewCollection } from 'types/sanity.types';

import FadeInAnimation from 'components/fade-in-animation';

import { styles } from '.';

type TProps = {
  review: ReviewCollection;
};

const ReviewItem = (props: TProps) => {
  const { review } = props;

  return (
    <FadeInAnimation>
      <div className={styles.container}>
        <div className={styles.body}>
          <p className="!text-base !leading-relaxed !font-light">
            {review.content}
          </p>
        </div>
        <div className={styles.foot.container}>
          <Avatar style={{ width: '45px', height: '45px' }}>
            <AvatarImage src={review.author?.image?.asset?.url} alt="review" />
            <AvatarFallback>
              {handleGenerateInitialsFromName(review.author?.name ?? '')}
            </AvatarFallback>
          </Avatar>
          <div className={styles.foot.body}>
            <p className={styles.foot.title}>{review.author?.name}</p>
            <p className={styles.foot.description}>{review.author?.caption}</p>
          </div>
        </div>
      </div>
    </FadeInAnimation>
  );
};

export default ReviewItem;
